( ( $ ) => {
        

	if ( $( 'form[id^="mktoForm_"]' ).length > 0 )
	{

		//HIDE HIDDEN DYNAMIC FIELDS SO THEY DON'T THROW OFF LAYOUT
		const hideFields = () => {
			const hiddenField = $(".mktoPlaceholder");
			const mktoField = $("fieldset .mktoFormRow");
			
				mktoField.each((_index, element) => {
			
						if ($(element).find(hiddenField).length !== 0) {
						  $(element).hide();
						}
						else {
						  $(element).show();
						}
				});
		  }

		$( 'form[id^="mktoForm_"]' ).each( ( ind, ele ) => {

			let form_id = $( ele ).attr( 'id' ).split( '_' );
			form_id = form_id[1];
            

			MktoForms2.loadForm(
				"//connect.phreesia.com",
				"508-AHM-437",
				form_id,
				( form ) => {
                    
					hideFields();

					/*form.onSuccess( () => {

                    });*/

				}
			);

			//HIDE OR SHOW HIDDEN DYNAMIC FIELDS SO THEY DON'T THROW OFF LAYOUT
			$(ele).on( 'change', ( event ) => {
				hideFields();
			   });
	
		} );
	}

	    /*REMOVE EXTRA LABEL FROM CHECKBOXES TO MARKETO FORMS FOR ADA COMPLACENCY AND HIDE HIDDEN DYNAMIC FIELDS FROM AFFECTING LAYOUT*/
		MktoForms2.whenRendered(function(mktoForm){
			const arrayify = getSelection.call.bind([].slice);
			let formEl = mktoForm.getFormElem()[0];
			
			/* the Checkbox field/s you want to alter */
			const labelEl = arrayify(formEl.querySelectorAll("input[type='checkbox']")).map(function(el){
				return el.name;
			});
	  
			
			
	   /* no need to touch below this line. This removes the extra label created by Marketo */
	   labelEl.forEach(function(fieldName){
		  let checkbox = formEl.querySelector("input[name='" + fieldName + "']"),
			  primaryLabel = formEl.querySelector("label[for='" + checkbox.id + "'].mktoLabel"),
			  secondaryLabel = formEl.querySelector("label[for='" + checkbox.id + "']:not(.mktoLabel)");
	  
		   if (primaryLabel){
				if(primaryLabel.getAttribute("data-content-migration-state") !== "done"){
					secondaryLabel.innerHTML = primaryLabel.innerHTML;
					primaryLabel.setAttribute("data-content-migration-state", "done");
					primaryLabel.remove();
				}
			   else {
				   return;
			   }
		   }
	   
	   });
			
	  
	  });
    
    /*HONEYPOT FOR MARKETO FORMS*/
  const mktoHoneypot = () => {
    if (!window.MktoForms2) {
      return;
    }

    window.MktoForms2.whenReady((form) => {
      form.onValidate(() => {
        const vals = form.vals();

        form.submittable(!!(vals.honeypot === ''));
      });
    });
  };

  mktoHoneypot();

} )( jQuery );

